import Image from 'next/image';
import Icon from './arrow_right_white.svg?url';
import type { SvgImageProps } from '../_type';

export const ArrowRightWhiteImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={Icon} alt={alt} {...props} />;
